import { jsx } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx("path", { d: "M3 4C5.01 6.59 10 13 10 13V20H14V13C14 13 18.98 6.59 21 4H3Z", fill: "currentColor", fillOpacity: 0.9 }) });
export default SvgFilter;
